import { AppList } from 'components/atoms';
import { parseStringIntoFormattedStringDate } from 'utils/parsers/dateTime/parseStringIntoFormattedStringDate';
import { WeeklyScheduleEntryDTO } from 'types/schedule/weeklySchedule';
import { WeeklyScheduleDaysList } from './WeeklyScheduleDaysList/WeeklyScheduleDaysList';

type WeeklyScheduleEntryItemProps = {
    entry: WeeklyScheduleEntryDTO;
};

export const WeeklyScheduleEntryItem = ({ entry }: WeeklyScheduleEntryItemProps) => {
    const dateFrom = entry.dateFrom ? parseStringIntoFormattedStringDate(entry.dateFrom) : '';
    const dateTo = entry.dateTo ? parseStringIntoFormattedStringDate(entry.dateTo) : '';
    const dateRange = dateFrom && dateTo ? `${dateFrom} - ${dateTo}` : dateFrom || dateTo;

    return (
        <AppList.Item key={`${entry.dateFrom}-${entry.dateTo}`} style={{ marginBottom: 16 }}>
            <div>
                {dateRange && <div style={{ marginBottom: 8, fontWeight: 500 }}>{dateRange}</div>}
                {entry.days && <WeeklyScheduleDaysList days={entry.days} />}
            </div>
        </AppList.Item>
    );
};
